import { ProjectId } from '@ply-io/ply-front-shared-utilities';
import { buildCrud, api } from './clients';

const AI_ASSISTANT_API_DOCS_ENDPOINT = 'ai-assistant-api-docs';

type ApiDocId = number;

type ApiDocResponse = {
	id: ApiDocId;
	service_name: string;
	url: string;
	pasted_documentation: string;
	project: ProjectId;
};

type ApiDocPayload = Omit<ApiDocResponse, 'id' | 'project'> & { project?: ApiDocResponse['project'] };

export const useAiAssistantApiDocsCrud = () => {
	const {
		create,
		partialUpdate,
		delete: deleteMethod,
	} = buildCrud<ApiDocId, ApiDocPayload, ApiDocResponse>(api, AI_ASSISTANT_API_DOCS_ENDPOINT);
	return { partialUpdate, create, deleteMethod };
};
